import React from 'react';

import { useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import RovoChatIcon from '@atlaskit/icon/core/rovo-chat';
import { usePublish } from '@atlaskit/rovo-triggers';

import { i18n } from './messages';

export type SummarizeInChatProps = {
	url: string | undefined;
	testId?: string;
	onClick?: () => void;
};

export const SummarizeInChatButton = ({ url, testId, onClick }: SummarizeInChatProps) => {
	const { formatMessage } = useIntl();
	const publish = usePublish('ai-mate');

	const promptRovoChat = (e: React.MouseEvent<HTMLButtonElement>) => {
		onClick?.();
		e.stopPropagation();

		if (!url) {
			return;
		}

		publish({
			type: 'browser-context-payload',
			source: 'search-result',
			data: {
				context: {
					browserUrl: url,
				},
			},
		});
		publish({
			type: 'chat-new',
			source: 'search-result',
			data: {
				dialogues: [],
				prompt: `Summarize ${url}`,
				name: `Summarize ${url}`,
			},
		});
	};

	return (
		<Button iconBefore={RovoChatIcon} spacing="compact" onClick={promptRovoChat} testId={testId}>
			{formatMessage(i18n.summarizeInChatButtonText)}
		</Button>
	);
};
